import { useEffect, useState } from 'react';

interface FiltrosCategoriasProps {
  categoriaAtiva: string;
  onCategoriaChange: (categoria: string) => void;
}

const categorias = [
  { id: 'todas', nome: 'Todas', icone: 'ri-grid-line' },
  { id: 'gratidao', nome: 'Gratidão', icone: 'ri-heart-line' },
  { id: 'superacao', nome: 'Superação', icone: 'ri-trophy-line' },
  { id: 'amor', nome: 'Amor', icone: 'ri-heart-2-line' },
  { id: 'carreira', nome: 'Carreira', icone: 'ri-briefcase-line' },
  { id: 'saude', nome: 'Saúde', icone: 'ri-heart-pulse-line' },
  { id: 'familia', nome: 'Família', icone: 'ri-group-line' },
  { id: 'sonhos', nome: 'Sonhos', icone: 'ri-star-line' }
];

export default function FiltrosCategorias({ categoriaAtiva, onCategoriaChange }: FiltrosCategoriasProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="sticky top-16 z-40 bg-gray-900/95 backdrop-blur-lg border-b border-white/10 py-6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-4 overflow-x-auto pb-2 scrollbar-hide">
          <span className="text-gray-400 text-sm font-medium whitespace-nowrap">Filtrar por:</span>
          
          <div className="flex gap-3">
            {categorias.map((categoria, index) => (
              <button
                key={categoria.id}
                onClick={() => onCategoriaChange(categoria.id)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-500 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
                } ${
                  categoriaAtiva === categoria.id
                    ? 'bg-gradient-to-r from-amber-500 to-yellow-500 text-black shadow-lg shadow-amber-500/30'
                    : 'bg-white/5 text-gray-300 border border-white/10 hover:border-amber-500/50 hover:text-amber-400'
                }`}
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                <i className={`${categoria.icone} text-lg`}></i>
                <span>{categoria.nome}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
